import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {IviMy23SharedService} from'./../ivi-my23-shared.service';


@Component({
    selector: 'app-ivi-my23-base',
    templateUrl: './ivi-my23-base.component.html',
    styleUrls: ['./ivi-my23-base.component.scss'],
    standalone: false
})
export class IviMy23BaseComponent implements OnInit {

  constructor(private route: ActivatedRoute,private router: Router, private iviDataService: IviMy23SharedService) { }

  ngOnInit(): void {
      // Title is set server-side based on vehicleMake for IVI head unit compatibility
      if(this.iviDataService.vehicleMake === 'acura'){
                this.router.navigate(['/ivi/my23/Acura/qr-code']);
      }else if(this.iviDataService.vehicleMake === 'honda'){
                this.router.navigate(['/ivi/my23/Honda/qr-code']);
      }else{
                this.router.navigate(['/not-found']);
      }
  }
}
